import React, { useState, useContext } from "react";
import "./modal.css"; // スタイル適用
import TreeView from "../../treeView/treeView";
import TreeViewContext from "../../../context/treeViewContext"; // TreeViewのコンテキスト

const Modal = ({ isOpen, onClose, onSelect, masterID }) => {
    const { selectedNode } = useContext(TreeViewContext); // TreeViewの選択ノードを取得

    if (!isOpen) return null; // モーダルが開かれていないときは表示しない

    const handleRegister = () => {
        if (selectedNode) {
            onSelect(selectedNode.id, selectedNode.text); // 親コンポーネント（MasterForm.js）にIDを渡す
        }
        onClose(); // モーダルを閉じる
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                {/* ヘッダー部分 */}
                <div className="modal-header">
                    <h2>配置先選択</h2>
                    <h3>配置させたい親を選択してください。</h3>
                    <button className="modal-button register" onClick={handleRegister}>登録</button>
                    <button className="modal-button cancel" onClick={onClose}>キャンセル</button>
                </div>

                {/* TreeViewを配置 */}
                <div className="modal-body">
                    <p>ツリーから選択してください</p>
                    <TreeView className="treeview-custom" masterID={masterID}/>
                </div>
            </div>
        </div>
    );
};

export default Modal;
